import type { ColumnDefinition } from '@trm/ui-kit-admin';

export const USER_COLUMNS: readonly ColumnDefinition[] = [
  { key: 'user', label: 'User', locked: true },
  { key: 'id', label: 'ID' },
  { key: 'created', label: 'Created' },
  { key: 'username', label: 'Username' },
  { key: 'accounts', label: '# Accounts' },
  { key: 'verification', label: 'Veriff Status' },
  { key: 'riskLabels', label: 'Veriff Risk Labels' },
  { key: 'addressVerification', label: 'Address Verification' },
  { key: 'role', label: 'Role' },
];

export const USERS_TABLE_ID = 'admin-users-v2';

const FRAUD_SERVICE_LABELS: Readonly<Record<string, string>> = {
  verification: 'Fraud Service Status',
  riskLabels: 'Fraud Review Labels',
};

export const userColumns = (kycReviewAssistEnabled: boolean): readonly ColumnDefinition[] =>
  kycReviewAssistEnabled
    ? USER_COLUMNS.map((column) => ({
        ...column,
        label: FRAUD_SERVICE_LABELS[column.key] ?? column.label,
      }))
    : USER_COLUMNS;
